import React from "react";

const EmptySVG = () => {
    return (
      <svg className="-z-1 absolute bottom-0 end-0" width="273" height="250" viewBox="0 0 273 250" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_1727_230)">
              <path d="M274.983 42.5186C261.682 42.5186 248.926 47.8596 239.521 57.3668C230.116 66.874 224.833 79.7685 224.833 93.2137C224.833 106.659 230.116 119.553 239.521 129.061C248.926 138.568 261.682 143.909 274.983 143.909L274.983 120.374C267.857 120.374 261.023 117.512 255.984 112.419C250.945 107.325 248.114 100.417 248.114 93.2137C248.114 86.0103 250.945 79.1021 255.984 74.0085C261.023 68.915 267.857 66.0535 274.983 66.0535L274.983 42.5186Z" fill="#15803d"/>
              <path d="M274.982 0C250.405 -2.94804e-07 226.835 9.82069 209.456 27.3016C192.077 44.7826 182.314 68.4918 182.314 93.2136C182.314 117.935 192.077 141.645 209.456 159.126C226.835 176.606 250.405 186.427 274.982 186.427L274.982 143.153C261.815 143.153 249.187 137.892 239.876 128.526C230.566 119.161 225.335 106.458 225.335 93.2136C225.335 79.9688 230.566 67.2664 239.876 57.9009C249.187 48.5354 261.815 43.274 274.982 43.274L274.982 0Z" fill="#166534"/>
              <circle cx="214.475" cy="222.95" r="59.962"
                      transform="rotate(180 214.475 222.95)" stroke="#16a34a"
                      strokeWidth="3.27065"/>
              <circle cx="214.476" cy="222.95" r="49.0598"
                      transform="rotate(180 214.476 222.95)" stroke="#16a34a"
                      strokeWidth="3.27065"/>
              <circle cx="214.475" cy="222.95" r="39.2478"
                      transform="rotate(180 214.475 222.95)" stroke="#16a34a"
                      strokeWidth="3.27065"/>
              <circle cx="214.476" cy="222.949" r="28.3457"
                      transform="rotate(180 214.476 222.949)" stroke="#16a34a"
                      strokeWidth="3.27065"/>
              <circle cx="214.475" cy="222.95" r="17.4435"
                      transform="rotate(180 214.475 222.95)" stroke="#16a34a"
                      strokeWidth="3.27065"/>
              <circle cx="214.476" cy="222.949" r="7.63152"
                      transform="rotate(180 214.476 222.949)" stroke="#15803d"
                      strokeWidth="3.27065"/>
              <rect x="193.216" y="180.976" width="55.6011" height="40.338"
                    transform="rotate(180 193.216 180.976)" fill="#16a34a"/>
              <path d="M137.615 235.487L137.615 179.886L193.216 179.886L137.615 235.487Z" fill="#166534"/>
              <path d="M53.3108 199.749L108.476 110.517L163.642 199.749H53.3108Z" stroke="#166534" strokeWidth="2.18043"/>
              <path d="M65.9582 91L123.08 182.578H8.83672L65.9582 91Z" fill="#166534"/>
          </g>
          <defs>
              <clipPath id="clip0_1727_230">
                  <rect width="273" height="250" fill="white"/>
              </clipPath>
          </defs>
      </svg>
  
    );
};

export default EmptySVG;
